import styled from "styled-components";

export const ButtonBoldText = styled.div`
  > .Polaris-Button > .Polaris-Button__Content > .Polaris-Button__Text {
    font-weight: 500;
  }
`;
